import axios from 'axios'
import querystring from 'querystring'
axios.defaults.withCredentials = true 
// axios.defaults.baseURL = 'stu/'  //本地
// axios.defaults.baseURL = 'https://dev.ctexcel.com.hk/ctgextrpc/stuActivity'  //測試
axios.defaults.baseURL = 'https://images.ctexcel.com.hk/ctgextrpc/stuActivity'  //正式

//1.记录页面的按钮/页面访问次数
export const accessCount = params => { return axios.post('accessCount', querystring.stringify(params)).then(res => res.data) }
//2.信息填写页面提交领卡信息
export const submitInfo = params => { return axios.post('submitInfo', querystring.stringify(params)).then(res => res.data) }
//3.上传证件照、图片 文件接口 
export const uploadFile = params => { return axios.post('uploadFile', querystring.stringify(params)).then(res => res.data) }
//4.支付页面，生成支付链接
export const getPayLink = params => { return axios.post('getPayLink', querystring.stringify(params)).then(res => res.data) }
//5.订购成功页面，获取订单信息
export const getOrderInfo = params => { return axios.post('getOrderInfo', querystring.stringify(params)).then(res => res.data) }
//6.购套餐输入iccid 提交后台检查iccid，获取访问资格
export const checkIccid = params => { return axios.post('checkIccid', querystring.stringify(params)).then(res => res.data) }
//7.获取PayPal支付状态
export const getPaypalStatus = params => { return axios.post('getPaypalStatus', querystring.stringify(params)).then(res => res.data) }
//8.转换月费计划列表(预转后)
export const getTransformPlans = params => { return axios.post('getTransformPlans', querystring.stringify(params)).then(res => res.data) }
//9.支付页面进入前，获取相关信息
export const toPay = params => { return axios.post('toPay', querystring.stringify(params)).then(res => res.data) }


// WEBPACK FOOTER //
// ./src/api/api.js